import { createSelector } from 'reselect';
import { prop } from 'ramda';

export const selectRouterDomain = prop('router');

export const selectPrevPathname = createSelector(
  selectRouterDomain,
  prop('prevPathname')
);
